import { useSearchParams, useNavigate } from "react-router-dom";
import Modal from "shared/components/feedback/modals/MasterModal";
import OfficesTable from "features/admin/offices/OfficesTable";
import PageWrapper from "app/components/PageWrapper";
import OfficesForm from "features/admin/offices/OfficesForm";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const action = searchParams.get("action");
    const id = searchParams.get("id");

    const onClose = () => {
        navigate(".", { replace: true });
    };

    if (action === "add") {
        return (
            <Modal
                title="Add Office"
                stickyAction={true}
                onRequestClose={onClose}
            >
                <OfficesForm key="new" onClose={onClose} />
            </Modal>
        );
    }

    const parsedId = Number.parseInt(id);

    if (action === "edit" && !Number.isNaN(parsedId)) {
        return (
            <Modal
                title="Edit Office"
                stickyAction={true}
                onRequestClose={onClose}
            >
                <OfficesForm
                    officeIdToEdit={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};
const Offices = () => {
    return (
        <PageWrapper
            title="Offices"
            menuOptions={[{ children: "Admin", to: "/admin" }]}
        >
            <FormPresenter />
            <OfficesTable />
        </PageWrapper>
    );
};

export default Offices;
